import type { SxProps, Theme } from '@mui/material';

export const styles = {
    paper: { p: 2, width: '100%' } as SxProps<Theme>,
    header: {
        display: 'flex',
        justifyContent: 'center',
        mb: 1,
    } as SxProps<Theme>,
    title: { color: 'grey.900', fontSize: '18px' } as SxProps<Theme>,
    submitBtn: (theme: Theme): SxProps<Theme> => ({
        backgroundColor: theme.palette.blue[700],
        color: theme.palette.white,
        my: 1,
        p: 1.25,
        width: '100%',
        textTransform: 'none',
        '&:hover': { backgroundColor: theme.palette.blue[800] },
        '&.Mui-disabled': {
            backgroundColor: theme.palette.grey[100],
            color: theme.palette.grey[400],
        },
    }),
    submitRow: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
    } as SxProps<Theme>,
    submitLabel: { fontSize: '14px', fontWeight: 700 } as SxProps<Theme>,
    submitTotal: { fontSize: '14px', fontWeight: 700 } as SxProps<Theme>,
    serviceCard: (theme: Theme): SxProps<Theme> => ({
        background: theme.palette.grey[30],
        p: 1.5,
        mt: 1,
    }),
    serviceRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: 1,
    } as SxProps<Theme>,
    serviceType: { fontSize: '14px', fontWeight: 600, color: 'grey.900' } as SxProps<Theme>,
    serviceMeta: { fontSize: '12px', color: 'grey.700' } as SxProps<Theme>,
    serviceActions: { display: 'flex', flexDirection: 'column' } as SxProps<Theme>,
    serviceTotal: { fontSize: '14px', color: 'grey.500' } as SxProps<Theme>,
};
